module.exports = __webpack_public_path__ + "img/active-calendar-icon.ec20d8c1.svg";